const envApiBaseUrl = import.meta.env.LH_TIMP_API_BASE_URL
const envAgGridApiBaseUrl = import.meta.env.LH_TIMP_AG_GRID_API_BASE_URL

const getLocalStorageItem = (key: string) => {
  if (globalThis.localStorage === undefined) {
    return null
  }

  return globalThis.localStorage.getItem(key)
}

const apiBaseUrlOverride = getLocalStorageItem('lhApiBase')
const agGridApiBaseUrlOverride = getLocalStorageItem('lhAGGridApiBase')

export const API_BASE_URL = apiBaseUrlOverride ?? envApiBaseUrl

export const AG_GRID_API_BASE_URL =
  agGridApiBaseUrlOverride ?? envAgGridApiBaseUrl
